import {
  __export
} from "./chunk-IEP6GGEX.mjs";

// src/SqlTransaction.ts
var SqlTransaction_exports = {};
__export(SqlTransaction_exports, {
  SqlTransaction: () => SqlTransaction,
  layer: () => layer
});
import * as SqlClient from "@effect/sql/SqlClient";
import * as Context from "effect/Context";
import * as Effect from "effect/Effect";
import * as Layer from "effect/Layer";
var SqlTransaction = class extends Context.Tag("@dxos/sql-sqlite/SqlTransaction")() {
};
var layer = Layer.effect(SqlTransaction, Effect.map(SqlClient.SqlClient, (sql) => ({
  withTransaction: (self) => sql.withTransaction(self)
})));

export {
  SqlTransaction,
  layer,
  SqlTransaction_exports
};
//# sourceMappingURL=chunk-75B7OGIR.mjs.map
